import { PublicArticleResponse } from '@ahora-patagonia/contracts';
import type { ApiClient } from '../../../shared/http/ApiClient.js';
import { fixtureNota, fixturesActivos } from '../../../shared/fixtures/publicFixtures.js';
import type { NotaData } from '../entities/NotaData.js';

/**
 * Acceso a una nota publicada por su dirección canónica. El response se valida con el
 * schema de contracts (falla rápido si API y sitio divergen). Con `VITE_PUBLIC_FIXTURES`
 * devuelve la nota de muestra del prototipo.
 */
export class NotaRepository {
  constructor(private readonly api: ApiClient) {}

  async porDireccion(year: string, month: string, urlKey: string): Promise<NotaData> {
    const fixtures = fixturesActivos();
    if (fixtures) return fixtureNota(fixtures);
    const data = await this.api.get<unknown>(
      `/public/articles/${encodeURIComponent(year)}/${encodeURIComponent(month)}/${encodeURIComponent(urlKey)}`,
    );
    return PublicArticleResponse.parse(data);
  }
}
